var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.buttonStyle(),on:{"click":_vm.select}},[_c('span',{staticClass:"inline-block",attrs:{"name":_vm.name}},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }